var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
/**
 * It's the function that takes an array as the first parameter, and takes n number of arrays as the second parameter,
 * and then compares the two to find the arraysDifference.
 *
 * @template T
 * @param {T[]} array
 * @param {...Array<any>} values
 *
 * @example
 * arraysDifference([1, 2, 3, 4], [1, 2]);
 * // return [3, 4]
 * @example
 * arraysDifference([1, 2, 3, 4], [1, 2], [3])
 * // return [4]
 *
 * @return {*}  {Array<T>}
 */
export var arraysDifference = function (array) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    return array.reduce(function (acc, value) { return (!values.flat().includes(value) ? __spread(acc, [value]) : acc); }, []);
};
//# sourceMappingURL=arraysDifference.js.map